module.exports = __webpack_public_path__ + "img/clover.12286542.png";